import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link, useHistory, useLocation } from "react-router-dom";
import { FormikForm, Section, AgGridDataTable } from "../";
import { Alert, Row, Col, Container } from "react-bootstrap";
import { Breadcrumbs } from "../../ssi";
import { useIsRegulator, useIsBulkManifest } from "../../../hooks";
import { useSelector } from "react-redux";
import { ProgressComponent } from "../../shared";
import urlParameterHelper from "../../../utilities/urlParameters";

function Report(props) {
  const history = useHistory();
  const agGridRef = useRef();
  let location = useLocation();
  const [hasError, setHasError] = useState({ error: false, message: "" });
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([{ headerName: "", field: "" }]);
  const [formParams, setFormParams] = useState([]);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [progressPercentage2, setProgressPercentage2] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(
    Math.round(Math.random() * (44 - 20)) + 20
  );
  const [stop, setStop] = useState(false);
  const [descriptionToggle, setDescriptionToggle] = useState(true);
  const toggleDescription = () => setDescriptionToggle(!descriptionToggle);
  const formRef = useRef();
  const user = useSelector((state) => state.user);
  const isRegulator = useIsRegulator();
  const isBulkManifest = useIsBulkManifest();
  const [source, setSource] = useState(axios.CancelToken.source());
  history.listen(() => {
    cancelCall();
  });
  const cancelCall = () => {
    source.cancel();
    setSource(axios.CancelToken.source());
  };

  const dateComparator = (date1, date2) => {
    var date1Number = monthToComparableNumber(date1);
    var date2Number = monthToComparableNumber(date2);
    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
  };

  const monthToComparableNumber = (date) => {
    if (
      date === undefined ||
      date === null ||
      (date.length > 10 && date.length < 9)
    ) {
      return null;
    }
    if (date.length === 8) {
      var yearNumber = date.substring(4, 8);
      var dayNumber = date.substring(2, 3);
      var monthNumber = date.substring(0, 1);
    } else if (date.length === 9) {
      var yearNumber = date.substring(5, 9);
      var dayNumber = date.substring(2, 4);
      var monthNumber = date.substring(0, 1);
    } else {
      var yearNumber = date.substring(6, 10);
      var dayNumber = date.substring(3, 5);
      var monthNumber = date.substring(0, 2);
    }
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
  };

  const setAgGrid = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let colDef = Object.keys(columnsArr).map((col) => {
      if (props.customGridCells) {
        var cellRend = props.customGridCells.filter(
          (object) => object.columnName === col
        );
        if (cellRend.length > 0) {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            sortable: true,
            hide: col.toLowerCase().includes("hide") || cellRend[0].hide === true ? true : false,
            comparator: col.toLowerCase().includes("date")
              ? dateComparator
              : null,
            cellRenderer: cellRend[0].cellRenderer,
          });
        } else {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            sortable: true,
            hide: col.toLowerCase().includes("hide") ? true : false,
            comparator: col.toLowerCase().includes("date")
              ? dateComparator
              : null,
          });
        }
      } else {
        colDefArr.push({
          headerName: col.replace(/_/g, " "),
          field: col,
          sortable: true,
          comparator: col.toLowerCase().includes("date")
            ? dateComparator
            : null,
        });
      }
    });

    if (props.pageTitle === "Waste Code By Year Matrix Report") {
      let arryLength = colDefArr.length;
      colDefArr.unshift(colDefArr.splice(arryLength - 1, 1)[0]);
      colDefArr.unshift(colDefArr.splice(arryLength - 1, 1)[0]);
      let arr1 = colDefArr.splice(0, 2);
      let arr2 = colDefArr.reverse();
      let newColDef = [...arr1, ...arr2];
      setColumnDefs(newColDef);
    } else if (props.customColumnDefs) {
      setColumnDefs(props.customColumnDefs);
    } else {
      setColumnDefs(colDefArr);
    }

    setRowData(data);
    if (props.setRowDataCount) {
      props.setRowDataCount(data.length);
    }
  };

  const search = async (formData, formikBag) => {
    let value = 100;
    let obj = {};
    setIsLoading(true);
    Object.keys(formData).forEach((key, i) => {
      if (formData[key] !== "") {
        obj[key] = formData[key];
      }
    });

    const qs = urlParameterHelper.stringify(obj);
    window.history.replaceState(null, `Hazardous Waste Tracking System: ${props.pageTitle}`, `${location.pathname}?${qs}`);
    let mqs = urlParameterHelper.parse(qs);
    delete mqs.multiShipYear;
    const query = urlParameterHelper.stringify(mqs);
    agGridRef.current.api.showLoadingOverlay();

    await axios
      .get(`${props.apiEndpoint}?${query}`, {
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (percentCompleted > 90) {
            setProgressPercentage2(value >= 100 ? value - 1 : value++);
            setStop(true);
          }
        },
      })
      .then((res) => {
        setStop(false); // stopping progress count
        setIsLoading(false);
        if (res.data.length === 0) {
          setColumnDefs([{ headerName: "", field: "" }]);
          setRowData([]);
          agGridRef.current.api.showNoRowsOverlay();
          //agGridRef.current.api.sizeColumnsToFit();
        } else {
          setAgGrid(res.data);
          agGridRef.current.api.hideOverlay();

          var allColumnIds = [];
          agGridRef.current.columnApi.getAllColumns().forEach((column) => {
            allColumnIds.push(column.colId);
          });
          agGridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
          //agGridRef.current.api.sizeColumnsToFit();
        }

        setHasError({ error: false, message: "" });
        setFormParams(formData);
        setHasSubmitted(true);
      })

      .catch((err) => {
        setIsLoading(false);
        let requiredFields = new Object();

        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response) {
          if (err.response.status === 400) {
            let requiredFields = new Object();

            Object.keys(err.response.data).forEach((key, i) => {
              requiredFields = {
                ...requiredFields,
                [key]: err.response.data[key][0],
              };
            });

            formikBag.setErrors(requiredFields);
          } else if (err.response.status === 500) {
            setHasError({
              error: true,
              message: "An error has occured. Please try again.",
            });
          } else {
            console.error(err);
          }
        } else {
          console.error(err);
        }
        setColumnDefs([{ headerName: "", field: "" }]);
        setRowData([]);
        setHasSubmitted(true);
        agGridRef.current && agGridRef.current.api.showNoRowsOverlay();
      });
    formikBag.setSubmitting(false);
  };

  const onSubmit = async (formData, formikBag) => {
    Object.keys(formData).map(function (key, index) {
      if (key.startsWith("multi")) {
        let object = formData[key].map((c) => c.value).join(",");
        let name = key.substr(5);
        formData[name] = object;
        // delete formData[key];
      }
    });
    search(formData, formikBag);
  };

  // useEffect(() => {
  //   if (props.searchOnInit) {
  //     formRef.current.resetForm();
  //     formRef.current.submitForm();
  //   }
  // }, [props.searchOnInit]);

  useEffect(() => {
    if (
      props.formRef &&
      props.formRef.current &&
      props.formRef.current.initialValues &&
      props.formRef.current.isSubmitting === false &&
      hasSubmitted === false &&
      props.searchOnInit
    ) {
      props.formRef.current.submitForm();
    } else if (
      formRef.current &&
      formRef.current.initialValues &&
      formRef.current.isSubmitting === false &&
      hasSubmitted === false &&
      props.searchOnInit
    ) {
      formRef.current.submitForm();
    }
  }, [])

  return (
    <React.Fragment>
      {!props.hideSection && (
        <Section title={props.pageTitle} type={"standout"} />
      )}

      <div id="page-container" className="container">
        {!props.hideSection && (
          <div className="mb-2">
            {props.breadcrumb ? (
              <div>
                <Breadcrumbs breadcrumbs={props.breadcrumb} />
              </div>
            ) : (
                <div className="m-t-sm">
                  <Link to={props.backToUrl}>Back to Reports Menu</Link>
                  <br />
                </div>
              )}
          </div>
        )}
        {props.reportDescription ?
          <Row>
            <Col>
              <div className="panel-group accordion " id="report-description-accordion" role="tablist" aria-multiselectable="true">
                <div className="panel panel-default report-description-card">
                  <div className="panel-heading" role="tab" id="report-description-heading" style={{ backgroundColor: "#e6e6e6" }}>
                    <h3 className="panel-title h4">
                      <a className="report-description-card-header collapsed py-2" data-toggle="collapse" data-parent="#report-description-accordion" href="#collapseManifests" aria-controls="collapseOne" onClick={toggleDescription}>
                        {`Report Description${descriptionToggle === false ? "..." : ""}`}
                        <i className={`ca-gov-icon-caret-${descriptionToggle === false ? "right" : "down"} ml-auto`} style={{ color: "black" }} />
                      </a>
                    </h3>
                  </div>
                  <div id="collapseReportDescription" className={`panel-collapse collapse ${descriptionToggle === true && "show"}`} role="tabpanel" aria-labelledby="report-description-heading" style={{ borderTop: "1px solid lightgray" }}>
                    <div className="p-3" style={{ backgroundColor: "#f2f2f2" }}>
                      {props.reportDescription}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          : null}
        <FormikForm
          initialFormValues={props.initialFormValues}
          schema={props.schema}
          formConfig={props.formConfig}
          onSubmit={onSubmit}
          cancelCall={cancelCall}
          formRef={props.formRef ? props.formRef : formRef}
        />
        {hasError.error && <Alert variant="danger">{hasError.message}</Alert>}
        {
          /* take out of 'user.isAuth &&' (isRegulator ||isBulkManifest) &&  to allow public export and download manifests list */ 
          (props.customButton && rowData.length > 0 )? 
            (
              <>
                <Row>
                  <Col lg={2} md={3} xs={6}>
                    <button
                      onClick={() => props.customButton[0].onClick(formParams)}
                      className="btn btn-standout"
                    >
                      {props.customButton[0].label}
                    </button>
                  </Col>

                  {/* render 2nd button, if one is provided */}
                  {props.customButton.length > 1 && <> 
                    &nbsp;
                    <Col lg={{ span: 2, offset: -10 }} md={3} xs={6}>
                      <button
                        onClick={() => props.customButton[1].onClick(formParams)}
                        className="btn btn-standout"
                      >
                        {props.customButton[1].label}
                      </button>
                    </Col>
                  </>}
                </Row>
                <br />
                <br />
              </>
            ) : null}
        {props.pageTitle.toLowerCase().includes("tonnage by waste code") ? (
          <div
            className="mb-2"
            style={{
              fontSize: "1rem",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            Disclaimer: The sum of the quantities may exceed the total tonnage
            because a manifest waste stream may contain multiple waste codes.
          </div>
        ) : null}
        <div className="m-b-md" style={{ position: "relative" }}>
          <ProgressComponent
            percent={progressPercentage}
            setProgressPercentage={setProgressPercentage}
            percent2={progressPercentage2}
            grid={true}
            isLoading={isLoading}
            value={value}
            stop={stop}
          />

          <AgGridDataTable
            agGridRef={agGridRef}
            columnDefs={columnDefs}
            rowData={rowData}
            initialPageSize={props.initialPageSize ? props.initialPageSize : 10}
            pageTitle={props.pageTitle}
            customCsvHeader={props.customCsvHeader}
            formConfig={props.formConfig}
            formParams={formParams}
            formRef={formRef}
            defaultExportParams={props.defaultExportParams}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default Report;
